import styles from './SelectionAchievements.module.css'
import clockAndCase from '../../images/clockAndCase.png'
import carImg from '../../images/achivmentCar.png'
import shieldImg from '../../images/achievmentShield.webp'
import cityImg from '../../images/cityAchievement.png'
import checkImg from '../../images/achievementCheck.png'

export default function SelectionAchievements(){

  return(
    <div className={styles.selectionAchievements}>
      <div className={styles.achievement}>
        <img className={styles.achievement__img} src={clockAndCase} alt="" />
        <h3 className={styles.achievement__text}>6 лет <br />успешной работы</h3>
      </div>
      <div className={styles.achievement}>
        <img className={styles.achievement__img} src={carImg} alt="" />
        <h3 className={styles.achievement__text}>1420 подобранных<br />автомобиля</h3>
      </div>
      <div className={styles.achievement}>
        <img className={styles.achievement__img} src={shieldImg} alt="" />
        <h3 className={styles.achievement__text}>Полная гарантия и<br />прозрачность, вплоть до выкупа</h3>
      </div>
      <div className={styles.achievement}>
        <img className={styles.achievement__img} src={checkImg} alt="" />
        <h3 className={styles.achievement__text}>135 параметров<br />проверки автомобиля</h3>
      </div>
      <div className={styles.achievement}>
        <img className={styles.achievement__img} src={cityImg} alt="" />
        <h3 className={styles.achievement__text}>Работаем в Санкт-Петербурге<br />и Ленинградской области</h3>
      </div>
    </div>
  )
}